export default "__VITE_ASSET__xcSF$BeS__"